export default __webpack_public_path__ + "static/media/Now-Black.a10b1f75.otf";